// extracted by mini-css-extract-plugin
export var parcelRow = "_sf-0";